import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import {CreateOrUpdateUserComponent} from '../users/createOrUpdateUser.component'
import { UsersListComponent } from '../users/usersList.component';
import {ConfigurationsComponent} from '../configurations/configurations.component';
import {ConfigsListComponent} from '../configurations/configsList.component';

import { DocumentsComponent } from '../documents/documents.component';
import { EmailTemplateListComponent } from '../emailTemplates/emailTemplateList.component';
import { EmailTemplateComponent } from '../emailTemplates/emailTemplate.component';
import {ActivityLogComponent} from '../activityLog/activityLog.component';
import {EditActivityLogComponent} from '../activityLog/editActivityLog.component';
import { ParametersComponent } from '../parameters/parameters.component';
import { SearchComponent } from '../search/search.component';


const routes: Routes = [
    {
        path: 'app',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: '/app/documents', pathMatch: 'full' },
            // { path: 'users/list',component: ListUserComponent },
            { path: 'users/crud/:action',component: CreateOrUpdateUserComponent },
            { path: 'parameters', component: ParametersComponent},
            { path: 'users/list', component: UsersListComponent},
            { path: 'configs/list', component: ConfigsListComponent},
            { path: 'configs/crud/:action',component : ConfigurationsComponent},
            { path: 'emailTemplate/list', component: EmailTemplateListComponent},
            { path: 'emailTemplate/crud/:action',component : EmailTemplateComponent},
            { path: 'activityLog/crud/:action',component: EditActivityLogComponent},
            { path: 'activityLog', component: ActivityLogComponent }    ,
                    { path: 'documents', component: DocumentsComponent },
            { path: 'search', component: SearchComponent },
            // { path: 'dashboard', component: DashboardComponent },
            { path: 'chart', loadChildren: '../charts/charts.module#ChartsModule' },
            { path: 'ecommerce', loadChildren: '../ecommerce/ecommerce.module#ECommerceModule' },
            { path: 'form', loadChildren: '../forms/forms.module#MyFormsModule' },
            { path: 'page', loadChildren: '../pages/pages.module#PagesModule' },
            { path: 'pglayout', loadChildren: '../page-layouts/page-layouts.module#PageLayoutsModule' },
            { path: 'table', loadChildren: '../tables/tables.module#MyTablesModule' },
            { path: 'ui', loadChildren: '../ui/ui.module#UIModule' },
        ]
    }
];

export const LayoutRoutingModule = RouterModule.forChild(routes);

